module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-589.9545af4.woff2";